import { EKeyCode } from '@/enums/e_key_code';
import { ELocalStorageKey } from '@/enums/ELocalStorageKey';
import i18n from '@/services/i18n/i18n';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { WATCHER_SHORTCUT__base } from '../../shortcuts/_watchers/WATCHER_SHORTCUT__base';

export function WatcherShortcutChangeLanguage() {
  /*
   * EVENTS
   */
  function on_shortcut_pressed() {
    let languages = Object.values(ENUM__language_type).sort();
    languages = languages.filter(language => language != ENUM__language_type.PIGDOG);

    const index_current = languages.indexOf(i18n.language);
    const index_next = (index_current + 1) % languages.length;

    const language_next = languages[index_next];

    localStorage.setItem(ELocalStorageKey.LANGUAGE, language_next);
    void i18n.changeLanguage(language_next);

    return true;
  }

  return <WATCHER_SHORTCUT__base key_codes={[EKeyCode.L]} {...{ on_shortcut_pressed }} />;
}
